var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73535 0.665039V2.46484H13.2646V0.665039H13.7354V2.46484H15.2998C15.8395 2.46484 16.3576 2.67989 16.7393 3.06152C17.1206 3.44312 17.335 3.96047 17.335 4.5V15.2998C17.335 15.8395 17.1209 16.3576 16.7393 16.7393C16.3576 17.1209 15.8395 17.335 15.2998 17.335H2.7002C2.16048 17.335 1.64238 17.1209 1.26074 16.7393C0.879106 16.3576 0.665039 15.8395 0.665039 15.2998V4.5C0.665039 3.96047 0.87935 3.44312 1.26074 3.06152C1.64238 2.67989 2.16048 2.46484 2.7002 2.46484H4.26465V0.665039H4.73535ZM13.3398 6.99512C12.7291 6.38006 11.735 6.37832 11.1221 6.99121L7.19922 10.9121L6.42871 10.1406C5.81582 9.52773 4.82069 9.52948 4.20996 10.1445C3.60251 10.7564 3.60439 11.7447 4.21387 12.3545L6.02246 14.1631C6.67263 14.8133 7.72672 14.8131 8.37695 14.1631L13.3359 9.20508C13.9457 8.59535 13.9472 7.60713 13.3398 6.99512Z",
    stroke: "#606060",
    strokeWidth: 1.33
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 14,
    height: 12,
    rx: 4,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5L6.64645 12.1464C6.84171 12.3417 7.15829 12.3417 7.35355 12.1464L12.5 7",
    stroke: "#606060",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.87c98d57de699f62420c9dca9b218396.svg";
export { ForwardRef as ReactComponent };